export default __webpack_public_path__ + "static/media/headshot.fa897ce8.jpg";